<template>
  <div class="pwc-event-detail">
    <van-image :src="cCover" width="100%" height="100%" fit="contain" style="position: relative;">
      <template v-slot:loading>
        <van-loading type="spinner" size="20" />
      </template>
    </van-image>
    <van-cell-group :border="false" class="pwc-event-basic">
      <div class="active-time">
        <div v-if="cStatus === '1'">距离活动开始还有</div>
        <div v-if="cStatus === '1'">{{ day }} 天 {{ hour }} 时</div>
        <div v-if="cStatus === '2'">距离活动结束还有</div>
        <div v-if="cStatus === '2'">{{ day }} 天 {{ hour }} 时</div>
        <div v-if="cStatus === '3'">活动已结束</div>
      </div>
      <van-cell :title="cTitle" :label="cSubject">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <!-- <div slot="label" v-html="cDescription" /> -->
      </van-cell>
      <!-- <van-cell :title="cDate" icon="underway-o" style="color: #d04a02;" /> -->
      <van-cell :title="cDate" icon="clock-o" />
      <van-cell :title="cAddress" icon="location-o" />
      <!-- <van-cell class="pwc-event-fee" :title="cPrice" icon="after-sale" /> -->
    </van-cell-group>
    <van-cell-group v-if="cShowImgDetail" :border="false" class="pwc-event-detail">
      <van-cell title="活动描述" />
      <van-image v-for="d in cDetails" :key="d" :src="d" width="7.5rem" fit="contain">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
    </van-cell-group>
    <van-cell-group v-if="cisShowContentDetail">
      <van-cell class="pwc-event-detail-title" title="活动描述">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div slot="label" v-html="cDescription" />
      </van-cell>
      <van-cell v-if="cisShowSpeakerTitle" class="pwc-event-speaker-title" title="主讲嘉宾" />
      <evt-speaker v-for="p in cEvent.speakers" :key="p.name" :profile="p" />
    </van-cell-group>
  </div>
</template>

<script>
import {
  Image,
  Cell,
  Loading,
  CellGroup
} from 'vant'
import EvtSpeaker from './EventSpeaker'
import dayjs from 'dayjs'

export default {
  components: {
    VanImage: Image,
    VanCell: Cell,
    VanLoading: Loading,
    VanCellGroup: CellGroup,
    EvtSpeaker
  },
  props: {
    event: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      cStatus: '',
      day: '',
      hour: ''
    }
  },
  computed: {
    cEvent() {
      // event maybe null
      return this.event || {}
    },
    // cStatus() {
    //   const now = new Date().getTime()
    //   const start = new Date(this.cEvent.startTime)
    //   const end = new Date(this.cEvent.endTime)
    //   if (now < start) {
    //     return '1' // 未开始
    //   } else if (now > start && now < end) {
    //     return '2' // 进行中
    //   } else {
    //     return '3' // 已结束
    //   }
    // },
    cCover() {
      return this.cEvent.coverUrl
    },
    cTitle() {
      return this.cEvent.eventName
    },
    cSubject() {
      return this.cEvent.subject
    },
    cisShowContentDetail() {
      let isShow = false
      const desc = this.cEvent.eventDescription || ''

      if (desc &&
          desc !== '') {
        isShow = true
      } else {
        isShow = false
      }
      return isShow
    },
    cisShowSpeakerTitle() {
      const spkers = this.cEvent.speakers || {}
      if (spkers && spkers.length > 0) {
        return true
      }
      return false
    },
    cDescription() {
      const arr = (this.cEvent.eventDescription || '').split('\n')
      return arr.join('<br>').trim()
    },
    cDate() {
      if (this.cEvent.dateForPrint && this.cEvent.dateForPrint.length < 15) {
        return `(UTC+8:00) ${(this.cEvent.dateForPrint || '').slice(0, 10)} ${this.cEvent.startEndTimeForPrint}`
      } else {
        return `(UTC+8:00) ${this.cEvent.dateForPrint}`
      }
    },
    cAddress() {
      return this.cEvent.location
    },
    cPrice() {
      return '免费'
    },
    cDetails() {
      return this.cEvent.detailImgUrls
    },
    cShowImgDetail() {
      let isShow = false

      if (this.cEvent.detailImgUrls &&
          this.cEvent.detailImgUrls.length > 0 &&
          this.cEvent.detailImgUrls[0] !== '') {
        isShow = true
      } else {
        isShow = false
      }
      return isShow
    }
  },
  watch: {
    event: {
      handler(val) {
        if (val) {
          const now = dayjs()
          // const timezoneOffset = now.getTimezoneOffset() // 时区分钟
          // now.setTime(now.getTime() + timezoneOffset * 60 * 1000 + 480 * 60 * 1000)
          const start = dayjs(this.cEvent.startTime)
          const end = dayjs(this.cEvent.endTime)
          // const start = new Date('2020-03-28T12:14:00')
          // const end = new Date('2020-03-30T08:08:00')
          if (now < start) {
            this.cStatus = '1'
            const s = (start - now) / 1000
            const h = Math.floor(s / 60 / 60)
            this.day = Math.floor(s / 60 / 60 / 24)
            this.hour = h - this.day * 24
            this.$emit('eventEnd', false)
          } else if (now > start && now < end) {
            this.cStatus = '2' // 进行中
            const s = (end - now) / 1000
            const h = Math.floor(s / 60 / 60)
            this.day = Math.floor(s / 60 / 60 / 24)
            this.hour = h - this.day * 24
            this.$emit('eventEnd', false)
          } else if (now > end) {
            this.cStatus = '3' // 已结束
            this.$emit('eventEnd', true)
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .pwc-event-detail {
    // background-color: #f7f7f7;
    .pwc-event-basic {
      .active-time {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        padding: 10px 20px;
        background-color: rgba(208, 74, 2, .1);
        color: #d04a02;
      }
      .pwc-event-fee {
        span {
          color: #ff9800;
        }
      }
    }

    .pwc-event-detail {
      margin-top: 10px;
      // border-top: 12px solid #f7f7f7
    }

    .pwc-event-detail-title {
      // text-align: center;
      padding-top: 4vh;
    }

    .pwc-event-speaker-title {
      text-align: center;
      margin-bottom: 2vh;
    }

    .van-cell:not(:last-child)::after {
      display: none !important;
    }

    .pwc-event-detail-des {
      font-size: 14px;
    }
  }
</style>
